var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9634 5.36985C13.8712 5.08637 13.6198 4.88567 13.3235 4.85886L9.28209 4.49195L7.68491 0.752632C7.56698 0.477908 7.29867 0.300598 7.00002 0.300598C6.70137 0.300598 6.43295 0.477908 6.31577 0.752632L4.71859 4.49195L0.676564 4.85886C0.380264 4.8862 0.129359 5.0869 0.0366454 5.36985C-0.0555345 5.65333 0.0295957 5.96427 0.25369 6.1608L3.30866 8.83957L2.4079 12.8068C2.342 13.0985 2.45522 13.4002 2.69726 13.5751C2.82736 13.6697 2.98021 13.7169 3.13359 13.7169C3.2654 13.7169 3.39731 13.6818 3.51513 13.6114L7.00002 11.5276L10.4843 13.6114C10.7399 13.7641 11.0613 13.7501 11.3028 13.5751C11.5448 13.4002 11.658 13.0985 11.5921 12.8068L10.6914 8.83957L13.7463 6.1608C13.9703 5.96427 14.0556 5.65397 13.9634 5.36985Z",
    fill: "#FBA919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGold);
export default __webpack_public_path__ + "static/media/star-gold.b4ddec3e4ac380a41bae26f98765e9cc.svg";
export { ForwardRef as ReactComponent };